export default __webpack_public_path__ + "static/media/1.85f1e10c.png";